import { isTouchEnabled } from '../../../../../../Theme';

export const getCombinationWithImageLineHeight = (mobileWidth: boolean) => {
  if (mobileWidth) {
    return 182;
  } else if (isTouchEnabled) {
    return 108;
  }

  return 72;
};
